import { render, staticRenderFns } from "./ListDepartmentNoteView.vue?vue&type=template&id=45133b0c&scoped=true"
import script from "./ListDepartmentNoteView.vue?vue&type=script&lang=js"
export * from "./ListDepartmentNoteView.vue?vue&type=script&lang=js"
import style0 from "./ListDepartmentNoteView.vue?vue&type=style&index=0&id=45133b0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45133b0c",
  null
  
)

export default component.exports